// extracted by mini-css-extract-plugin
export default {"container":"Admin_container__uFu-T","childContainer":"Admin_childContainer__a6EuW","adminPanel":"Admin_adminPanel__6-Skr"};